// @import types
import { IUser } from 'app_types/userTypes'
import { IUserData } from 'app_types/userTypes';
// @end

// @export const
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const UPDATE_TOKEN = 'UPDATE_TOKEN'
export const CHANGE_SCREEN_MODE = 'CHANGE_SCREEN_MODE'
export const UPDATE_USER_DATA = '[Auth] UPDATE_USER_DATA'
export const UPDATE_USER_STORE = '[Auth] UPDATE_USER_STORE'
export const MOODLE_AUTH = '[MOODLE] AUTH'
export const MOODLE_FORM_REQUEST = '[MOODLE] FORM REQUEST'
// @end

// @declare interfaces
export interface IUserState {
  user: null | IUser
  isAuth: boolean
  moodleAuth: boolean
  moodleFormRequest: any
}
// @end

// @declare actions
interface ILoginAction {
  type: typeof LOGIN
  payload: IUser
}
interface ILogoutAction {
  type: typeof LOGOUT
  payload: null
}
interface IUpdateTokenAction {
  type: typeof UPDATE_TOKEN
  payload: string
}

interface IUpdateUserDataAction {
  type: typeof UPDATE_USER_DATA
  payload: IUserData | undefined
}

interface IUpdateUserStoreAction {
  type: typeof UPDATE_USER_STORE
  payload: IUser | null
}

interface IChangeScreenMode {
  type: typeof CHANGE_SCREEN_MODE
  payload: any
}

interface IMoodleAuthChangeAction {
  type: typeof MOODLE_AUTH,
  payload: boolean
}

interface IMoodleAuthFormRequestAction {
  type: typeof MOODLE_FORM_REQUEST,
  payload: boolean
}
// @end

// @export interfaces
export type AuthActionTypes =
  | ILoginAction
  | ILogoutAction
  | IUpdateTokenAction
  | IChangeScreenMode
  | IUpdateUserDataAction
  | IMoodleAuthChangeAction
  | IMoodleAuthFormRequestAction
  | IUpdateUserStoreAction
// @end

